import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

type Props = {
    onChange: Function;
    // notLogged?: boolean;
};

const LoginStatus = (props: Props) => {
    const userLogged = useSelector((state: any) => state.user.value);
    // const notLogged = useState<boolean>(false);
    // const navigate = useNavigate();
    useEffect(()=>{
        console.log('userLogged', userLogged);
        props.onChange(userLogged);
    }, [userLogged])

    return (
        <></>
    )
}


export default LoginStatus;